export default __webpack_public_path__ + "static/pay-n-play-spelsidor-har-snabba-uttag-cdea68c10132d8156aec831c620d1b2f.jpg";